module.exports = __webpack_public_path__ + "media/icons/notification-close-grey-34e108ca.svg";